import React from "react";
import { Link } from "react-router-dom";
import { FlaskConical, ArrowRight } from "lucide-react";

/**
 * FDA Disclaimer banner shown above the main footer on every page.
 * Per RUO compliance copy provided 2026-02.
 */
export const FdaDisclaimerBanner = () => (
  <section
    data-testid="fda-disclaimer-banner"
    aria-label="FDA Disclaimer"
    className="bg-gradient-to-br from-[#f9efe6] via-cream-100 to-[#eef3e8] border-y border-charcoal-100/50"
  >
    <div className="container-x py-10 md:py-12">
      <div className="border-l-[3px] border-sage-400 pl-5 md:pl-7 max-w-5xl">
        <div className="flex items-center gap-2 mb-3">
          <span className="w-7 h-7 rounded-full bg-sage-100 text-sage-700 flex items-center justify-center">
            <FlaskConical className="w-3.5 h-3.5" strokeWidth={2} />
          </span>
          <span className="font-display text-sm font-bold tracking-[0.22em] uppercase text-charcoal-600">
            FDA Disclaimer
          </span>
        </div>

        <p className="text-sm md:text-[15px] leading-relaxed text-charcoal-500 max-w-4xl">
          Statements made regarding our products have not been evaluated by the U.S. Food and Drug
          Administration. The efficacy of these products has not been confirmed by FDA-approved
          research. Products are not intended to diagnose, treat, cure, or prevent any disease.
          Information presented on this website is not a substitute for, or alternative to,
          information from a qualified health care practitioner. These compounds are for research
          use only and not intended for human consumption.{" "}
          <Link
            to="/legal/disclaimer"
            data-testid="fda-disclaimer-read-full"
            className="inline-flex items-center gap-1 text-sage-700 hover:text-sage-800 font-medium underline-offset-4 hover:underline transition-colors"
          >
            Read the full disclaimer
            <ArrowRight className="w-3.5 h-3.5" strokeWidth={2.2} />
          </Link>
        </p>
      </div>
    </div>
  </section>
);

export default FdaDisclaimerBanner;
